import React, { useContext, useEffect, useState } from "react";
import LoadingGif from "@public/img/loading.gif";
import Tabs from "@/component/commom/tabs";
import PaginationView from "@/component/commom/pagination";
import { WatchedMovieData } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { userRepo } from "@/repo/user-repo";
import WatchedMovieCard from "./_components/watched-movie-card";
import { AppContextType, WonmovContext } from "@/context/app-context";

var TABS = ["فیلم ها", "سریال ها"];

export default function WatchListPage() {
  var setNotification = useContext<AppContextType>(WonmovContext).setNotification;
  var selectedTabState = useState(0);
  var selectedTab = selectedTabState[0];
  var setSelectedTab = selectedTabState[1];
  var moviesState = useState<WatchedMovieData[]>([]);
  var movies = moviesState[0];
  var setMovies = moviesState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var pageState = useState(1);
  var page = pageState[0];
  var setPage = pageState[1];
  var paginationState = useState<Pagination | undefined>(undefined);
  var pagination = paginationState[0];
  var setPagination = paginationState[1];

  var contentType = selectedTab === 0 ? "movie" : "series";
  var isSeries = selectedTab === 1;

  useEffect(function () {
    setLoading(true);
    userRepo.getWatchedMovies(contentType, page).then(function (res) {
      setMovies(res.data ? res.data : []);
      setPagination(res.pagination ? res.pagination : undefined);
      setLoading(false);
    });
  }, [contentType, page]);

  var handleTabChange = function (tab: number) {
    setSelectedTab(tab);
    setPage(1);
  };

  var handleRemove = function (id: number) {
    if (!window.confirm("آیا می خواهید این فیلم/سریال را حذف کنید؟")) {
      return;
    }
    setMovies(function (prev) {
      return prev.filter(function (item) {
        return item.id !== id;
      });
    });
    userRepo.removeWatchedMovie(id).then(function (res) {
      if (!res.status) {
        setNotification({ type: "danger", message: res.message });
      }
    });
  };

  var bodyClassName = "profile-panel__body";
  if (loading || movies.length === 0) {
    bodyClassName = bodyClassName + " profile-panel__body--center";
  }

  return (
    <div className="profile-panel watch-list-page">
      <h2 className="profile-panel__title">فیلم و سریال های دیده شده</h2>

      <Tabs tabs={TABS} selectedTab={selectedTab} onChange={handleTabChange} />

      <div className={bodyClassName}>
        {loading && (
          <div className="profile-panel__loading">
            <img src={LoadingGif} alt="loading" />
          </div>
        )}

        {!loading && movies.length === 0 && (
          <div className="profile-panel__empty">
            <p className="profile-panel__empty-title">
              <span className="profile-panel__empty-title-accent">موردی</span> یافت نشد
            </p>
            <p className="profile-panel__empty-desc">
              هنوز {isSeries ? "سریالی" : "فیلمی"} در این بخش تماشا نکرده‌اید.
            </p>
          </div>
        )}

        {!loading && movies.length > 0 && (
          <div className="watch-list-grid">
            {movies.map(function (item) {
              return (
                <WatchedMovieCard
                  key={item.id + "-" + item.season_number + "-" + item.episode_number}
                  item={item}
                  isSeries={isSeries}
                  onRemove={function () {
                    handleRemove(item.id);
                  }}
                />
              );
            })}
          </div>
        )}
      </div>

      {pagination && (
        <div className="profile-panel__pagination">
          <PaginationView pagination={pagination} black={true} onChange={setPage} />
        </div>
      )}
    </div>
  );
}
